<script setup lang="ts">
const { currentUserProfileAvatar, userInfosProfile } = storeToRefs(
  useSmarticoUserInfos(),
);

const isReady = computed(() => !!userInfosProfile.value);
</script>

<template>
  <div
    class="w-[30px] h-[30px] lg:h-[40px] lg:w-[40px] flex items-center justify-center overflow-hidden rounded-[9px] bg-white relative"
  >
    <!-- Skeleton placeholder -->
    <div
      class="absolute inset-0 flex items-center justify-center bg-gray transition-opacity duration-300"
      :class="isReady ? 'opacity-0 pointer-events-none' : 'opacity-100'"
    >
      <NuxtIcon
        class="text-[#9ca3af] text-[22px] lg:text-[30px] animate-pulse"
        name="user/user_circle"
      />
    </div>

    <!-- Avatar image -->
    <img
      alt="Avatar"
      class="w-full h-full object-cover transition-opacity duration-300"
      :class="isReady ? 'opacity-100' : 'opacity-0'"
      draggable="false"
      :src="currentUserProfileAvatar"
    />
  </div>
</template>
